export default __webpack_public_path__ + "static/media/flag2.fa230ced.jpg";